import { TypeTooltipFields } from '@/contentful-types'
import { withContentful } from '@/siteBuilder/renderer/contentful/withContentful'
import Tooltip, { TooltipProps } from './Tooltip'

const ContentfulTooltip = withContentful<TypeTooltipFields, TooltipProps>(Tooltip, {})

export default ContentfulTooltip
